<template>
  <div class="wish-frame">
    <div class="real-wish">
      <h3 class="accessibility oob" tabindex="0">{{ headline }}</h3>
      <surface-post-author v-if="xAuthor"
                           :post="post"
                           :user="user"
                           class="author" />
      <section class="words">
        <surface-post-words-edit :post="post"
                                 @text-change="changePostText({
                                   postCid: post.cid, attributes: $event
                                 })" />
      </section>
      <surface-post-attachment v-if="xAttachment" :post="post" :is-being-edited="true" />
      <surface-post-moderation v-if="xModeration"
                               :post="post"
                               :can-i-moderate="canIModerate"
                               :is-being-edited="true"
                               @approve="approvePost({postCid: post.cid})"
                               @delete="confirmDelete" />
      <section v-if="xComments || xReactions" class="stalker-bar">
        <surface-post-comments v-if="xComments && !xPostCommentsInPanel"
                               :post="post"
                               :user="user"
                               :comment-ids="postCommentIds"
                               :comments="wallComments"
                               :is-commentable="isCommentable" />
      </section>
    </div>
    <surface-post-actions :x-author="xAuthor"
                          :post="post"
                          :luminance="luminance"
                          :is-editable-by-current-user="isEditableByCurrentUser"
                          :is-being-edited="true"
                          @delete="confirmDelete" />
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex'
import SurfacePostAuthor from 'vuecomponents/surface_post_author'
import SurfacePostWordsEdit from 'vuecomponents/surface_post_words_edit'
import SurfacePostAttachment from 'vuecomponents/surface_post_attachment'
import SurfacePostModeration from 'vuecomponents/surface_post_moderation'
import SurfacePostComments from 'vuecomponents/surface_post_comments'
import SurfacePostActions from 'vuecomponents/surface_post_actions'
import IntlMixin from 'vuemixins/intl_mixin'
import OutsideEventsMixin from 'vuemixins/outside_events_mixin'
import { isUrl } from 'bits/url'
import { $ } from 'bits/jquery'

export default {
  components: {
    SurfacePostAuthor,
    SurfacePostWordsEdit,
    SurfacePostAttachment,
    SurfacePostComments,
    SurfacePostActions,
    SurfacePostModeration,
  },
  mixins: [IntlMixin, OutsideEventsMixin],
  props: ['post', 'index', 'edit', 'isLast'],
  computed: {
    isPublished () { return this.post.published },
    subject () { return this.post.subject },
    body () { return this.post.body },
    sectionId () { return this.post.wall_section_id },
    headline () { return this.post.headline },
    ...mapState({
      user: 'user',
    }),
    ...mapState('comment', {
      commentBeingEditedId: 'commentBeingEditedId',
      wallComments: 'commentEntities',
    }),
    ...mapGetters('comment', {
      wallCommentIdsByPost: 'commentIdsByPost',
    }),
    ...mapGetters([
      'xAuthor',
      'isBackchannel',
      'isCommentable',
      'isReactable',
      'canIModerate',
      'canIWrite',
      'format',
      'xPostCommentsInPanel',
    ]),
    showInEditMode ()      { return !this.isBackchannel },
    hasAttachment () {
      const attachment = this.post.attachment
      return !!attachment && isUrl(attachment)
    },
    postCommentIds ()    { return this.wallCommentIdsByPost[this.post.id] || [] },
    xAttachment () { return this.showInEditMode || this.hasAttachment },
    xReactions ()  { return (this.isReactable) },
    xComments ()   {
      return this.isPublished &&
            (this.isCommentable || this.postCommentIds.length > 0)
    },
    xModeration () { return !this.isPublished },
    luminance ()              { return $('.beethoven-preview-image', this.$el).data('luminance') },
    wasWrittenByCurrentUser () { return !!this.user.id && this.post.author_id === this.user.id },
    // Either the current user is a moderator or current user is the author and wall is writable
    isEditableByCurrentUser () {
      return this.canIModerate ||
            (this.wasWrittenByCurrentUser && this.canIWrite)
    },
  },
  methods: {
    ...mapActions('post', ['changePostText', 'stopEditingPost', 'deletePost', 'approvePost']),
    onOutsideClick () {
      this.stopEditingPost()
    },
    onEscape () {
      this.stopEditingPost()
    },
    confirmDelete () {
      if (!this.post.id /* post is new */ || (!this.post.body && !this.post.subject && !this.post.attachment) || confirm(this.__('Are you sure you want to delete this post? This cannot be undone!'))) {
        this.deletePost({ post: this.post })
        this.stopEditingPost()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.stalker-bar {
  html[data-layout=map] & {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    background-color: rgba(black, 0.04);
    .surface-post-reaction {
      background-color: transparent !important;
    }
    .surface-post-comments {
      background-color: transparent !important;
    }
  }
  html > [data-color-scheme=dark] & {
    background-color: rgba(black, 0.06);
    .surface-post-reaction {
      background-color: transparent !important;
    }
    .surface-post-comments {
      background-color: transparent !important;
    }
  }
}
</style>
